import * as React from 'react';

const blogIconSmall = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="4" fill="white" />
    <path
      d="M10.5 0L14.4705 3.97046C14.6536 4.15355 14.9567 4.13071 15.1103 3.92225L17.5034 0.674061C17.7092 0.394701 17.5097 0 17.1628 0H10.5Z"
      fill="url(#paint0_linear_23111_854)"
    />
    <path
      d="M10.5 0L6.52954 3.97046C6.34645 4.15355 6.04332 4.13071 5.88974 3.92225L3.49662 0.674061C3.2908 0.394702 3.49026 0 3.83725 0H10.5Z"
      fill="url(#paint1_linear_23111_854)"
    />
    <path
      d="M11.8937 4.90202L9.75562 4.15771L10.4999 19.0393L13.4633 15.5643C13.5234 15.4938 13.5497 15.4005 13.5353 15.3089L11.8937 4.90202Z"
      fill="url(#paint2_linear_23111_854)"
    />
    <path
      d="M9.10627 4.90202L7.46465 15.3089C7.45021 15.4005 7.47651 15.4938 7.53664 15.5643L10.5 19.0393V4.15771L9.10627 4.90202Z"
      fill="url(#paint3_linear_23111_854)"
    />
    <path
      d="M11.8937 4.90205L13.0935 2.5936L10.4999 0L9.75562 2.78897L10.4999 4.90205H11.8937Z"
      fill="url(#paint4_linear_23111_854)"
    />
    <path
      d="M10.5001 0L7.90649 2.5936L9.10633 4.90205H10.5001V0Z"
      fill="url(#paint5_linear_23111_854)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_23111_854"
        x1="16.0147"
        y1="3.18739"
        x2="9.71654"
        y2="-3.45014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6DFE9" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_23111_854"
        x1="8.51471"
        y1="3.18739"
        x2="2.21654"
        y2="-3.45014"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D6DFE9" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_23111_854"
        x1="12.9595"
        y1="16.632"
        x2="7.65553"
        y2="16.1302"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_23111_854"
        x1="10.0187"
        y1="16.632"
        x2="5.73948"
        y2="16.3064"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_23111_854"
        x1="12.5681"
        y1="4.10907"
        x2="8.15125"
        y2="2.99532"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_23111_854"
        x1="10.0918"
        y1="4.10907"
        x2="6.57661"
        y2="3.42033"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#2744FF" />
        <stop offset="1" stopColor="#B9D5FF" />
      </linearGradient>
    </defs>
  </svg>
);

export default blogIconSmall; 
